import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=c0310c88&scoped=true&"
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"
import style0 from "./vip.vue?vue&type=style&index=0&id=c0310c88&scoped=true&lang=css&"
import style1 from "./vip.vue?vue&type=style&index=1&id=c0310c88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0310c88",
  null
  
)

export default component.exports